import logger from "../../../utils/logger";

export function transform(currentDict, compareDict, updateState) {
  let counter = 0;
  const tempCounts = [];
  Object.keys(currentDict).forEach((emotion) => {
    counter += currentDict[emotion];
    tempCounts.push({
      name: emotion,
      current: currentDict[emotion],
      compare: compareDict[emotion],
    });
  });

  updateState.counter = counter;
  updateState.counts = tempCounts;
}
export function transformAllActions(
  currentActionDict,
  compareActionDict,
  updateState
) {
  let actionsCounter = 0;
  let compareActionsCounter = 0;

  Object.values(currentActionDict).forEach((count) => {
    actionsCounter += count;
  });

  Object.values(compareActionDict).forEach((count) => {
    compareActionsCounter += count;
  });

  const normalizeKey = (key) => {
    if (typeof key !== "string") return key;
    const trimmed = key.trim();
    return trimmed.toLowerCase().startsWith("other") ? "Other" : trimmed;
  };

  const normalizedCurrent = {};
  Object.entries(currentActionDict || {}).forEach(([key, val]) => {
    const norm = normalizeKey(key);
    normalizedCurrent[norm] = (normalizedCurrent[norm] || 0) + (val || 0);
  });

  const normalizedCompare = {};
  Object.entries(compareActionDict || {}).forEach(([key, val]) => {
    const norm = normalizeKey(key);
    normalizedCompare[norm] = (normalizedCompare[norm] || 0) + (val || 0);
  });

  const actionCounts = [];
  Object.keys(normalizedCurrent).forEach((action) => {
    const current = normalizedCurrent[action] || 0;
    const compare = normalizedCompare[action] || 0;
    const currentPercent =
      actionsCounter > 0 ? Math.round((current / actionsCounter) * 100) : 0;
    const comparePercent =
      compareActionsCounter > 0
        ? Math.round((compare / compareActionsCounter) * 100)
        : 0;
    const change = currentPercent - comparePercent;

    actionCounts.push({
      name: action,
      current,
      compare,
      currentPercent,
      comparePercent,
      change,
    });
  });

  updateState.actionsCounter = actionsCounter;
  updateState.compareActionsCounter = compareActionsCounter;
  updateState.actionCounts = actionCounts;
}

export function transformActions(impactfulActions, updateState) {
  const num = 3;
  const requiredObj = {
    action: {},
    emotion: {},
  };

  // logger.log(impactfulActions);

  if (
    !impactfulActions ||
    (Object.keys(impactfulActions.action || {}).length < 1 &&
      Object.keys(impactfulActions.emotion || {}).length < 1)
  ) {
    updateState.threeImpactfulActions = requiredObj;
    return;
  }

  ["action", "emotion"].forEach((category) => {
    if (impactfulActions[category]) {
      Object.keys(impactfulActions[category])
        .sort(
          (a, b) =>
            impactfulActions[category][b] - impactfulActions[category][a]
        )
        .slice(0, 3)
        .forEach((key) => {
          requiredObj[category][key] = impactfulActions[category][key];
        });
    }
  });

  logger.log(requiredObj);
  updateState.threeImpactfulActions = requiredObj;
}

export function transformFilteredData(
  studentEmotionData,
  percentage,
  updateState
) {
  const formattedStudentData = Object.entries(studentEmotionData)
    .map(([name, data]) => ({
      name,
      count: data.count,
      total: data.total,
      percent: (data.count / data.total) * 100,
      actions: data.actions,
    }))
    .filter((student) => student.percent > percentage);
  updateState.chosenPercentage = percentage;
  updateState.studentEmotionData = formattedStudentData;
}
export function transformStudentSupportData(
  studentSupportData,
  percentage,
  updateState
) {
  const formattedSupportData = Object.entries(studentSupportData)
    .map(([name, data]) => ({
      name,
      count: data.count,
      total: data.total,
      percent: (data.count / data.total) * 100,
      actions: data.actions,
    }))
    .filter((student) => student.percent > percentage);
  updateState.chosenPercentage = percentage;
  updateState.studentSupportData = formattedSupportData;
}

export function computeParticipationPercentChange(
  currentParticipants,
  compareParticipants,
  updateState
) {
  const currentCount = currentParticipants.size;
  const compareCount = compareParticipants.size;
  const percentChange =
    compareCount > 0
      ? Math.round(((currentCount - compareCount) / compareCount) * 100)
      : 0;

  updateState.participationPercentChange = percentChange;
}
